// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModelContextMenu_root_y7A {
  font-family: 'Inter Tight', sans-serif;
  color: white;
  display: inline-block;
  margin-left: 0.5em;
}

@media screen and (min-width: 896px) {
  .ModelContextMenu_modelTable_Qr6 {
    border: 0px;
    margin-top: 6px;
    margin-left: 12px;
    margin-right: 12px;
    padding-top: 0px;
    float: left;
  }
  
  .ModelContextMenu_modelTable_Qr6 td {
    border: 0px;
    padding-bottom: 3px;
    padding-left: 12px;
  }
}

@media screen and (max-width: 896px) {
  .ModelContextMenu_modelTable_Qr6 {
    border: 0px;
    margin-top: 0px;
    margin-left: 12px;
    margin-right: 12px;
    padding-top: 0px;
    font-size: 0.85em;
    float: left;
    width: 10em;
  }
  
  .ModelContextMenu_modelTable_Qr6 td {
    border: 0px;
    padding-bottom: 3px;
    width: 8em;
  }
}

.ModelContextMenu_modelTable_Qr6 tr {
  border: 0px;
}

.ModelContextMenu_thumb_bu9 {
  width: 4.1em;
  height: 4.1em;
  background-color: \$gray-darker;
  border: none;
  display: inline-block;
  margin: .5em;
  padding: 0em;
  border-radius: 2px;
  box-shadow: 4px 4px 4px #303030;
  float: left;
  border: 1px solid \$gray-darker;
}

.ModelContextMenu_thumb_bu9 img {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  display: inline;
  border-style: none;
}

.ModelContextMenu_statusText_Sof {
  line-height: 1.5em;
}

.ModelContextMenu_comment_p0m {
  line-height: 1.5em;
  font-size: 0.7em;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModelContextMenu.scss"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".root {\r\n  font-family: 'Inter Tight', sans-serif;\r\n  color: white;\r\n  display: inline-block;\r\n  margin-left: 0.5em;\r\n}\r\n\r\n@media screen and (min-width: 896px) {\r\n  .modelTable {\r\n    border: 0px;\r\n    margin-top: 6px;\r\n    margin-left: 12px;\r\n    margin-right: 12px;\r\n    padding-top: 0px;\r\n    float: left;\r\n  }\r\n  \r\n  .modelTable td {\r\n    border: 0px;\r\n    padding-bottom: 3px;\r\n    padding-left: 12px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 896px) {\r\n  .modelTable {\r\n    border: 0px;\r\n    margin-top: 0px;\r\n    margin-left: 12px;\r\n    margin-right: 12px;\r\n    padding-top: 0px;\r\n    font-size: 0.85em;\r\n    float: left;\r\n    width: 10em;\r\n  }\r\n  \r\n  .modelTable td {\r\n    border: 0px;\r\n    padding-bottom: 3px;\r\n    width: 8em;\r\n  }\r\n}\r\n\r\n.modelTable tr {\r\n  border: 0px;\r\n}\r\n\r\n.thumb {\r\n  width: 4.1em;\r\n  height: 4.1em;\r\n  background-color: $gray-darker;\r\n  border: none;\r\n  display: inline-block;\r\n  margin: .5em;\r\n  padding: 0em;\r\n  border-radius: 2px;\r\n  box-shadow: 4px 4px 4px #303030;\r\n  float: left;\r\n  border: 1px solid $gray-darker;\r\n}\r\n\r\n.thumb img {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: inline;\r\n  border-style: none;\r\n}\r\n\r\n.statusText {\r\n  line-height: 1.5em;\r\n}\r\n\r\n.comment {\r\n  line-height: 1.5em;\r\n  font-size: 0.7em;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ModelContextMenu_root_y7A`,
	"modelTable": `ModelContextMenu_modelTable_Qr6`,
	"thumb": `ModelContextMenu_thumb_bu9`,
	"statusText": `ModelContextMenu_statusText_Sof`,
	"comment": `ModelContextMenu_comment_p0m`
};
module.exports = ___CSS_LOADER_EXPORT___;
